import React from 'react';
import Profile from '../components/Auth/Profile';

const ProfilePage: React.FC = () => <Profile />;

export default ProfilePage; 